module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header",
    attrs: {
      "id": "topbar"
    }
  }, [_c('span', {
    staticClass: "btn-link toggle-sidebar d-lg-none pg pg-menu",
    on: {
      "click": _vm.toggleMenu
    }
  }, [_c('i', {
    staticClass: "iconfont icon-expand"
  })]), (_vm.routesPure.length) ? _c('div', {
    staticClass: "d-flex"
  }, [_c('Breakcrumb', {
    attrs: {
      "routesPure": _vm.routesPure
    }
  })], 1) : _c('div', {
    staticClass: "d-flex"
  }, [_c('Logo'), _c('div', {
    staticClass: "toolbar-version d-sm-block"
  }, [_vm._v(_vm._s(_vm.version))])], 1), _c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('Setting', {
    attrs: {
      "realName": _vm.realName
    }
  }), _c('Toolbar', {
    staticClass: "d-lg-block"
  }), _c('Quickview')], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-46022294","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/containers/Home/Topbar/index.vue
// module id = 1746
// module chunks = 1